export default __webpack_public_path__ + "static/media/camaro.204c9443.jpg";